/** @format */

export const warningLimitsModule = 'sis-components.constant.warningLimits';

(function () {
    angular.module(warningLimitsModule, []).constant('WarningLimits', {
        COURSE_UNIT_EXPIRY_WARNING_PERIOD_MONTHS: 12,
        MODULE_EXPIRY_WARNING_PERIOD_MONTHS: 12,
    });
})();
